import React, { useState, useEffect } from "react";
import { 
  Box, Button, TextField, MenuItem, Select, Typography, Tooltip, 
  useTheme, useMediaQuery, FormControl, Snackbar 
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Autocomplete from '@mui/material/Autocomplete';
import MuiAlert from '@mui/material/Alert';

const Assessmentmodify = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const vertical = 'top';
  const horizontal = 'center';
  
  const [open, setOpen] = useState(false);
  const [quizError, setQuizError] = useState(false);
  const [selectedAssessmentName, setSelectedAssessmentName] = useState('');
  const [assessmentDate, setAssessmentDate] = useState('');
  const [updatedQuizResponse, setUpdatedQuizResponse] = useState([]);
  const [quizAssign, setQuizAssign] = useState({ errorMessage: "" });
  const [quizNameAssign, setQuizNameAssign] = useState({ errorMessage: "" });
  const [quizDateAssign, setQuizDateAssign] = useState({ errorMessage: "" });
  const [submitCompleted, setSubmitCompleted] = useState(false);

  const [quizType, setQuizType] = useState([]);
  const [assessmentType, setAssessmentType] = useState('');
  const [filteredQuizTypeList, setFilteredQuizTypeList] = useState([]);

  // ---------- OPEN / CLOSE DIALOG ----------
  const handleClickOpen = () => setOpen(true);
  const handleClose = () => {
    setSelectedAssessmentName('');
    setAssessmentType('');
    setFilteredQuizTypeList([]);
    setOpen(false);
  };

  // ---------- FETCH QUIZ TYPES ----------
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/quizdetails/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          const activeQuizzes = data.filter(item => item.status === 'Active');
          setQuizType(
            activeQuizzes.map((item) => ({
              name: item.name,
              organization_type: item.organization_type,
            }))
          );
        }
      })
      .catch((error) => console.error(error));
  }, []);

  // ---------- HANDLE TYPE CHANGE ----------
  const handleAssessmentTypeChange = (event) => {
    const selectedAssessmentType = event.target.value;
    setAssessmentType(selectedAssessmentType);

    if (selectedAssessmentType === "") {
      setFilteredQuizTypeList([]);
      return;
    }

    const filtered = quizType.filter(
      (item) => item.organization_type === selectedAssessmentType
    );
    setFilteredQuizTypeList(filtered.map((item) => ({ name: item.name })));
  };

  // ---------- PREFILL EXISTING DATA ----------
  useEffect(() => {
    if (open) {
      // Prefill Assessment Type
      if (props.OrganizationType === "Common") {
        setAssessmentType("Common");
        const commonQuizzes = quizType.filter(
          (item) => item.organization_type === "Common"
        );
        setFilteredQuizTypeList(commonQuizzes.map((item) => ({ name: item.name })));
      } else if (props.OrganizationType === "Individual") {
        setAssessmentType("Individual");
        const individualQuizzes = quizType.filter(
          (item) => item.organization_type === "Individual"
        );
        setFilteredQuizTypeList(individualQuizzes.map((item) => ({ name: item.name })));
      }

      // Prefill Assessment Name
      if (props.AssessmentName) {
        setSelectedAssessmentName(props.AssessmentName);
      }

      // Prefill Assessment Date
      if (props.AssessmentDate) {
        const formatted = formatDate(props.AssessmentDate);
        setAssessmentDate(formatted);
      }
    }
  }, [open, props.OrganizationType, props.AssessmentName, props.AssessmentDate, quizType]);

  // ---------- HELPER ----------
  function formatDate(dateString) {
    const parts = dateString.split('/');
    if (parts.length !== 3) return dateString;
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
  }

  // ---------- INPUT HANDLERS ----------
  const handleAssessmentInput = (e, newValue) => {
    setSelectedAssessmentName(newValue ? newValue.name : '');
  };

  const handleDateChange = (event) => {
    setAssessmentDate(event.target.value);
  };

  // ---------- SUBMIT ----------
  const handleSubmitClick = (e) => {
    e.preventDefault();

    if (!selectedAssessmentName) {
      setQuizNameAssign({ errorMessage: "Please select an assessment name" });
      return;
    }

    if (!assessmentDate) {
      setQuizDateAssign({ errorMessage: "Please select an assessment date" });
      return;
    }

    const selectedLabId = props.LabID;
    const labType = props.LabType;

    fetch(`${process.env.REACT_APP_API_URL}/api/checklabassessment/${selectedAssessmentName}/${labType}/${selectedLabId}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.exists) {
          setQuizAssign({ errorMessage: "Assessment already exists. Please select a different assessment." });
          setQuizError(true);
        } else {
          const prevAssessmentName = props.AssessmentName;
          const payload = {
            assessmentDate,
            labId: props.LabID,
            assessmentName: selectedAssessmentName,
          };

          fetch(`${process.env.REACT_APP_API_URL}/api/quizassignupdate/${prevAssessmentName}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            body: JSON.stringify(payload),
          })
            .then((response) => {
              if (response.ok) {
                handleClose();
                setSubmitCompleted(true);
                OnOkClick();
              }
              return response.json();
            })
            .then((data) => {
              if (data.code === 500) {
                setQuizAssign({ errorMessage: data.message });
                setQuizError(true);
              } else {
                handleClose();
                setSubmitCompleted(true);
                OnOkClick();
                setUpdatedQuizResponse({ name: data.name, date: data.date });
              }
            })
            .catch(() => setQuizAssign({ errorMessage: "Something went wrong" }));
        }
      })
      .catch(() => setQuizAssign({ errorMessage: "Something went wrong" }));
  };

  const OnOkClick = () => {
    setSubmitCompleted(false);
    props.onModified(updatedQuizResponse);
  };

  const isUpdateDisabled = !selectedAssessmentName || selectedAssessmentName.trim() === "" || !assessmentDate;
  // ---------- RENDER ----------
  return (
    <>
      <Tooltip title="Edit Assessment" arrow>
        <IconButton aria-label="edit" onClick={handleClickOpen}>
          <EditIcon style={{ color: "#009688" }} />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullScreen={isMobile}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">
          <Typography sx={{
              fontSize: { xs: '1.25rem', sm: '1.5rem' },
              fontWeight: 'bold', // makes it bold text
              textAlign: { xs: 'left', md: 'left' },
              lineHeight: 1.3,
            }}>Edit Assessment
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ width: '100%', pt: 2 }}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" sx={{ fontSize: '1rem' }}>
              Assignment Name : <Typography component="span">{props.AssignmentName}</Typography>
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" sx={{ fontSize: '1rem' }}>
              Current Organization Type : <Typography component="span">
                {props.OrganizationType === 'Common' ? 'Public Assessment' : 'Customer Owned Assessment'}
              </Typography>
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" sx={{ fontSize: '1rem' }}>
              Current Assessment Name : <Typography component="span">{props.AssessmentName}</Typography>
            </Typography>
          </Box>

          {/* Assessment Type */}
          <Box sx={{
            display: "flex",
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: { xs: 1, sm: 2 },
            mb: 2
          }}>
            <Typography color="textPrimary" variant="h6" sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>
              Assessment Type :
            </Typography>
            <FormControl sx={{ minWidth: { xs: '100%', sm: 200 } }}>
              <Select
                labelId="assessmentType"
                id="assessmentType"
                value={assessmentType}
                onChange={handleAssessmentTypeChange}
                size="small"
                sx={{ backgroundColor: 'white' }}
                displayEmpty
              >
                <MenuItem value="">-- Select Assessment Type --</MenuItem>
                <MenuItem value="Common">Public</MenuItem>
                <MenuItem value="Individual">Customer Owned</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Assessment Name */}
          <Box sx={{ mb: 2 }}>
            <Autocomplete
              fullWidth
              id="assessment_name"
              options={filteredQuizTypeList}
              getOptionLabel={(option) => option.name}
              value={filteredQuizTypeList.find((option) => option.name === selectedAssessmentName) || null}
              onChange={handleAssessmentInput}
              renderInput={(params) => (
                <TextField {...params} label="Select Assessment Name" required size="small" />
              )}
            />
            {quizNameAssign?.errorMessage && (
              <Typography color="error" align="center" sx={{ fontSize: "0.813rem", mt: 1.25 }}>
                {quizNameAssign.errorMessage}
              </Typography>
            )}
          </Box>

          {/* Assessment Date */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="h6" sx={{ fontSize: '1rem', mb: 1 }}>
              Choose the Assessment Date
            </Typography>
            <TextField
              type="date"
              fullWidth
              id="assessment_date"
              value={assessmentDate || ''}
              onChange={handleDateChange}
              size="small"
            />
            {quizDateAssign?.errorMessage && (
              <Typography color="error" align="center" sx={{ fontSize: "0.813rem", mt: 1.25 }}>
                {quizDateAssign.errorMessage}
              </Typography>
            )}
          </Box>
        </DialogContent>

        {quizError ? (
            <Box sx={{ px: 3, pb: 2 }}>
              <Typography color="error" align="center">{quizAssign.errorMessage}</Typography>
            </Box>
          ) : (
            <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
              <Tooltip title="Cancel" arrow>
                <Button 
                  onClick={handleClose} 
                  variant="contained"
                  color="secondary"
                  sx={{ borderRadius: '50px', px: 3, py: 1 }}
                >
                  Cancel
                </Button>
              </Tooltip>

              <Tooltip title="Update Assessment" arrow>
                <span>
                  <Button
                    type="submit"
                    variant="contained"
                    onClick={handleSubmitClick}
                    color="primary"
                    disabled={!selectedAssessmentName || selectedAssessmentName.trim() === "" || !assessmentDate}
                    sx={{ borderRadius: '50px', px: 3, py: 1 }}
                  >
                    Update
                  </Button>
                </span>
              </Tooltip>
            </DialogActions>
          )}

      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={submitCompleted}
        key={vertical + horizontal}
        autoHideDuration={2000}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity="success"
          sx={{ backgroundColor: "#38761d" }}
        >
          You have successfully updated the assessment!
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default Assessmentmodify;
